import { render, staticRenderFns } from "./ChamadosFechados.vue?vue&type=template&id=119e70c1&scoped=true"
import script from "./ChamadosFechados.vue?vue&type=script&lang=js"
export * from "./ChamadosFechados.vue?vue&type=script&lang=js"
import style0 from "./ChamadosFechados.vue?vue&type=style&index=0&id=119e70c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119e70c1",
  null
  
)

export default component.exports